<template>
  <div class="ai-section">
    <div class="section-title">
      {{ title }}
    </div>

    <div
        class="best-worst-card"
        v-for="item in items"
        :key="item.label"
    >
      <span>{{ item.label }}</span>
      <strong>{{ item.name }}</strong>
      <em>{{ item.score }}</em>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BestWorstBlock',

  props: {
    title: String,
    items: Array
  }
};
</script>

<style scoped>
.ai-section {
  border-top: 1px solid #e1e1e1;
  padding-top: 14px;
  margin-bottom: 22px;
}

.section-title {
  margin-bottom: 12px;
  color: #111;
  font-size: 14px;
  font-weight: 900;
}

.best-worst-card {
  border: 1px solid #e5e5e5;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.best-worst-card span {
  display: block;
  color: #666;
  font-size: 11px;
  margin-bottom: 4px;
}

.best-worst-card strong {
  display: block;
  color: #111;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
}

.best-worst-card em {
  display: block;
  margin-top: 4px;
  color: #39aa94;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
}
</style>
